import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "postFix", "onClear", "disabled"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var defineAdditionalProps = function defineAdditionalProps(_ref) {
  var _value$length, _props$dataValue;
  var value = _ref.value,
    postFix = _ref.postFix,
    onClear = _ref.onClear,
    disabled = _ref.disabled,
    props = _objectWithoutProperties(_ref, _excluded);
  var charsLength = (_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : (_props$dataValue = props['data-value']) === null || _props$dataValue === void 0 ? void 0 : _props$dataValue.length;
  var isValueDefined = !!charsLength;
  return _objectSpread(_objectSpread({}, props), {}, {
    value: value,
    postFix: postFix,
    onClear: onClear,
    disabled: disabled,
    onFocus: function onFocus(e) {
      var _props$onFocus;
      return (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 ? void 0 : _props$onFocus.call(props, value, e);
    },
    onBlur: function onBlur(e) {
      var _props$onBlur;
      return (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 ? void 0 : _props$onBlur.call(props, value, e);
    },
    onChange: function onChange(e) {
      var _props$onChange;
      return (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, e.target.value, e);
    },
    withPostFix: !!postFix && isValueDefined,
    withClearButton: onClear && !disabled && isValueDefined
  });
};